import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout.tsx';
import NewDashboard from './pages/NewDashboard.tsx';
import Login from './pages/Login.tsx';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import AuthGuard from './components/AuthGuard.tsx';

// Köpek Yönetimi
import OteldekiKopekler from './pages/OteldekiKopekler.tsx';
import KopekGirisCikis from './pages/KopekGirisCikis.tsx';
import Aktiviteler from './pages/Aktiviteler.tsx';
import GecmisZiyaretler from './pages/GecmisZiyaretler.tsx';
import KopekDurumGuncellemeleri from './pages/KopekDurumGuncellemeleri.tsx';


// Personel
import Personel from './pages/Personel.tsx';

// Raporlar
import DolulukRaporu from './pages/DolulukRaporu.tsx';
import AnketSonuclari from './pages/AnketSonuclari.tsx';
import AylikOdemeRaporu from './pages/AylikOdemeRaporu.tsx';

// Ayarlar
import Ayarlar from './pages/Ayarlar.tsx';
import SubeBilgileri from './pages/SubeBilgileri.tsx';

// Context Providers
import { PersonnelProvider } from './context/PersonnelContext.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import { GelirProvider } from './context/GelirContext.tsx';
import { GiderProvider } from './context/GiderContext.tsx';
import { KopekProvider } from './context/KopekContext.tsx';

function App() {
  return (
    <AuthProvider>
      <AuthGuard>
        <PersonnelProvider>
          <GelirProvider>
            <GiderProvider>
              <KopekProvider>
                <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            {/* Dashboard */}
            <Route index element={<NewDashboard />} />
            
            {/* Köpek Yönetimi */}
            <Route path="otel" element={<OteldekiKopekler />} />
            <Route path="giris-cikis" element={<KopekGirisCikis />} />
            <Route path="aktiviteler" element={<Aktiviteler />} />
            <Route path="durum" element={<KopekDurumGuncellemeleri />} />
            <Route path="gecmis" element={<GecmisZiyaretler />} />
            
            
            {/* Personel */}
            <Route path="personel" element={<Personel />} />
            
            {/* Raporlar */}
            <Route path="doluluk" element={<DolulukRaporu />} />
            <Route path="odeme" element={<AylikOdemeRaporu />} />
            <Route path="anket" element={<AnketSonuclari />} />
            <Route path="gelir-raporu" element={<div>Gelir Raporu - Yakında</div>} />
            <Route path="gunluk-rapor" element={<div>Günlük Rapor - Yakında</div>} />
            
            {/* Ayarlar */}
            <Route path="ayarlar" element={<Ayarlar />} />
            <Route path="sube" element={<SubeBilgileri />} />
            <Route path="fiyat" element={<div>Fiyat Ayarları - Yakında</div>} />
            <Route path="bildirim" element={<div>Bildirim Ayarları - Yakında</div>} />
           </Route>
                </Routes>
              </KopekProvider>
            </GiderProvider>
          </GelirProvider>
        </PersonnelProvider>
      </AuthGuard>
    </AuthProvider>
  );
}

export default App;